export default __webpack_public_path__ + "static/media/france.5c236c11.svg";